
export const localStorageFrontDeskPrinterKey = 'FRONT_DESK_PRINTER';
export const localStorageBarPrinterKey = 'BAR_PRINTER';
export const localStorageCocinaPrinterKey = 'COCINA_PRINTER';
export const localStorageDotcomPrinterKey = 'DOTCOM_PRINTER';
export const localStorageServicesPrinterKey = 'SERVICES_PRINTER';
export const localStoragePrecuentaPrinterKey = 'PRECUENTA_PRINTER';

export const printAreas = {
    cocina: 'cocina',
    bar: 'bar',
    dotcom: 'dotcom',
    servicios: 'servicios',
    recepcion: 'recepcion',
    sipandfly: 'sipandfly'
};

export const getPrinterIdByKey = (key) => {

    if (getPrinterByKey(key)) {
        return getPrinterByKey(key).id;
    }
    return null;
};

export const getPrinterByKey = (key) => {

    const actualLounge = JSON.parse(window.localStorage.lounge);

    if (window.localStorage[key])
        return JSON.parse(window.localStorage[key]);
    else if (actualLounge && actualLounge.config && actualLounge.config.printers && actualLounge.config.printers[key])
        return JSON.parse(actualLounge.config.printers[key]);

    return null;
};


export const getPrinterIdByPrintArea = (printArea) => {
    switch (printArea) {
        case printAreas.cocina:
            return getPrinterIdByKey(localStorageCocinaPrinterKey);
        case printAreas.bar:
            return getPrinterIdByKey(localStorageBarPrinterKey);
        case printAreas.dotcom:
            return getPrinterIdByKey(localStorageDotcomPrinterKey);
        case printAreas.servicios:
            return getPrinterIdByKey(localStorageServicesPrinterKey);
        case printAreas.recepcion:
            return getPrinterIdByKey(localStorageFrontDeskPrinterKey);
        default:
            break;
    }
};





// Si no existe impresora dedicada, utilizar Recepción.
export const getPrecuentaPrinterId = () => {
    return getPrinterIdByKey(localStoragePrecuentaPrinterKey)
        || getPrinterIdByKey(localStorageFrontDeskPrinterKey);
};
